import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAccountList } from '../../api/accounts'
import { API_BO } from '../../conf'
import { fetchDispath } from '../../functions/fetch'
import { loginAccount } from '../../api/users'
import { Button, List, ListItem, ListItemText, Typography, ListItemIcon, ListItemButton } from '@mui/material';
import { Link } from 'react-router-dom';
import * as actions from '../../reducers/formTable';
import CheckIcon from '@mui/icons-material/Check';
import { headerUnSetProject } from '../../reducers/header'
import { editUser, loadPermissions } from '../../reducers/users';
import { changeToken } from '../../localStorage'

const formName = 'accountList'
function Acceptance(props) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchDispath({
      progress: true,
      request: getAccountList,
    })).then(res => {
      dispatch(actions.loadFormTable({ ...res }, { name: formName, id: 'id' }))
    }).catch(err => console.log(err))
  }, [dispatch])

  const onClickFunction = (row, obj) => {
    if (!obj.id) return;
    dispatch(fetchDispath({
      body: {
        accountId: obj.id
      },
      progress: true,
      request: loginAccount,
    })).then(res => {
      dispatch(headerUnSetProject())
      dispatch(loadPermissions({ permissions: res.permissions }))
      dispatch(editUser({
        token: res.token,
        refreshToken: res.refreshToken,
        accountId: res.accountId,
        accountName: res.accountName,
      }))
      changeToken(res)
      props.history.push(API_BO + '/facility/our')
    }).catch(err => console.log(err))
  }
  const auth = useSelector(state => state.user?.auth)
  const allIds = useSelector(state => state.formTable[formName]?.allIds) || []
  const byId = useSelector(state => state.formTable[formName]?.byId) || {}
 
  const toLinkAdd = React.forwardRef((props, ref) => (
    <Link ref={ref} to={API_BO + `/a-panel`} {...props} />
  ));
  return (
    <div className='App-paper'>
      <Typography variant='h6'>Выберите аккаунт</Typography>
      {auth.g&& <Button component={toLinkAdd} color="primary">Панель</Button>}
      <List component="nav">
        {allIds.map(key => {
          const obj = byId[key]
          return <ListItem key={key} disablePadding>
            <ListItemButton onClick={() => onClickFunction(key, obj)} selected={auth.accountId === obj.id}>
              <ListItemIcon>
                {auth.accountId === obj.id && <CheckIcon style={{ color: '#2e7d32' }} />}
              </ListItemIcon>
              <ListItemText primary={obj.name} secondary={`${obj.shortName || ''} ${obj.inn ? ('ИНН ' + obj.inn) : ''}`} />
            </ListItemButton>
          </ListItem>
        })}
      </List>
    </div>
  )
}

export default Acceptance;